module.exports = __webpack_public_path__ + "static/media/28.d0a7a869.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/28.png
// module id = 531
// module chunks = 0